import React from "react";

export default function MSAccess_DateDiff() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_DateDiff</h1>
      <p>This is the MSAccess_DateDiff component generated from the SQL JSON.</p>
    </div>
  );
}
